import merge from 'merge';

export function findKeyInObj(obj, key) {
  if (!key || !key.split) {
    return null;
  }
  return key.split('.').reduce((acc, cv) => {
    if (acc !== null && typeof acc !== 'undefined') {
      return acc[cv];
    }
    return null;
  }, obj);
}

export function findKeyParentInObj(obj, key) {
  if (key.indexOf('.') === -1) {
    return obj;
  }
  const pathParts = key.split('.');
  pathParts.pop();
  return findKeyInObj(obj, pathParts.join('.'));
}

/**
 * See if two objects contain all the same key/value pairs
 */
export function areKeyValuesEqual(obj1, obj2) {
  const k1 = Object.keys(obj1);
  const k2 = Object.keys(obj2);

  if (k1.length !== k2.length) {
    return false;
  }

  for (let i = 0; i < k1.length; i++) {
    const k = k1[i];
    if (obj1[k] !== obj2[k]) {
      return false;
    }
  }
  return true;
}

export function stripNullAndUndefined(obj) {
  return Object.keys(obj).reduce((acc, cv) => {
    const val = obj[cv];
    if (val !== null && typeof val !== 'undefined') {
      acc[cv] = val;
    }
    return acc;
  }, {});
}

export function flattenObject(obj) {
  if (!obj || typeof obj !== 'object') {
    return {};
  }

  const result = {};
  Object.keys(obj).forEach(cv => {
    const val = obj[cv];
    if (typeof val === 'object') {
      const flatObj = flattenObject(val);
      Object.keys(flatObj).forEach(k => {
        result[cv + '.' + k] = flatObj[k];
      });
    } else {
      result[cv] = val;
    }
  });
  return result;
}

export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export function deepClone(obj) {
  return merge.recursive(true, obj);
}
